import { createSelector } from 'reselect'
import { EmptyArray } from 'lib/array/arrayUtils'
import getExperienceItemsView from 'checkout/selectors/view/itemViews/getExperienceItemsView'
import { getPromoKeyForLoyaltyItem } from 'lib/promo/promoMappers'

const getCheckoutExperiencePointsCalculationRequests = createSelector(
  (state: App.State) => getExperienceItemsView(state),
  (state: App.State) => state.checkout.promo?.loyaltyPointsBonusResultV1,
  (experienceViews, promoLoyaltyBonusResultV1): Array<App.LoyaltyDefaultPointsEarnCalculationRequest> => {
    if (!experienceViews.hasRequiredData) return EmptyArray

    return experienceViews.data.flatMap((itemView) => itemView.ticketViews.map((ticketView): App.LoyaltyDefaultPointsEarnCalculationRequest => ({
      price: ticketView.totals.price,
      loyaltyProductType: 'experience',
      itemId: ticketView.item.itemId,
      promoKey: getPromoKeyForLoyaltyItem(promoLoyaltyBonusResultV1, { filter: { itemId: ticketView.item.itemId } }),
    })))
  },
)

export default getCheckoutExperiencePointsCalculationRequests
